export enum CompensationPlan {
  Binary = 'binary',
  Matrix = 'matrix',
  Unilevel = 'unilevel',
}
